/**
 * React Query keys for the member-facing event surfaces.
 *
 * `all` is the invalidation root, mirroring `auditKeys`/`usersKeys`. `featured`
 * and `section` are parameterless: the backend resolves each surface from its
 * own clock, so there is nothing client-side to key on. `detail` (MYN-93) is
 * the one exception - it is keyed by id, since it reads one specific event
 * rather than resolving a surface.
 */
export const publicEventsKeys = {
  all: ['events', 'public'] as const,
  featured: () => ['events', 'public', 'featured'] as const,
  section: () => ['events', 'public', 'section'] as const,
  detail: (id: string) => ['events', 'public', 'detail', id] as const,
};

/**
 * Public (account-less) registration status (FR-286). Keyed by event and token,
 * so a token replaced from the email link reads afresh. Memory only: nothing
 * here is persisted or logged.
 */
export const guestRegistrationKeys = {
  /** Prefix of every status key for one event, for invalidation. */
  forEvent: (eventId: string) => ['events', 'guest-registration', eventId] as const,
  status: (eventId: string, token: string) => ['events', 'guest-registration', eventId, token] as const,
};
